<template>
  <main>
    <v-dialog
      :value="dialog"
      :max-width="1000"
      @input="$emit('update:dialog')"
      scrollable
    >
      <v-card class="orders" max-width="1000px" v-if="!loading">
        <v-card-title class="py-0 justify-center">
          <span class="secondary--text font-bold pt-2">
            {{ $t("order_details") }}</span
          >
        </v-card-title>
        <v-card-subtitle class="mt-1">
          <h3 class="text-center primary--text">
            {{ car_rent_order.car_rent_name }}
          </h3>
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" lg="8">
                <v-row>
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("invoice_and_detials") }}
                      </span>
                    </v-chip>
                  </v-col>
                  <v-col cols="12">
                    <v-card flat class="orders__invoice">
                      <v-container>
                        <v-row>
                          <v-col cols="12" lg="6">
                            <span class="secondary--text size-16 weight-800">
                              {{ $t("table.service_request_date") }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6" class="d-flex justify-end">
                            <span class="secondary--text size-16 weight-800">
                              {{ convertDateAndTime(car_rent_order.starts_at) }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <span class="secondary--text size-16 weight-800">
                              {{ $t("table.persons_count") }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6" class="d-flex justify-end">
                            <span class="secondary--text size-16 weight-800">
                              {{
                                `${car_rent_order.persons_count} ${$t(
                                  "persons"
                                )}`
                              }}
                            </span>
                          </v-col>

                          <v-col
                            cols="12"
                            lg="6"
                            class="align-self-center d-flex"
                          >
                            <span class="secondary--text size-16 weight-800">
                              {{ $t("table.trip_price_per_person") }}
                            </span>
                          </v-col>
                          <v-col
                            cols="12"
                            lg="6"
                            class="py-0 d-flex justify-end"
                          >
                            <span class="primary--text size-16 weight-800">
                              {{ car_rent_order.car_rent_price }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <span class="secondary--text size-16 weight-800">
                              {{ $t("table.duration") }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6" class="d-flex justify-end">
                            <span class="secondary--text size-16 weight-800">
                              {{
                                `${
                                  car_rent_order.car_rent_duration_in_hours
                                } ${$t("h")}`
                              }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions class="px-0 mx-0 d-flex flex-wrap">
                        <v-col
                          cols="12"
                          lg="6"
                          class="align-self-center d-flex"
                        >
                          <span class="error--text size-16 weight-800">
                            {{ $t("table.total_price") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="d-flex justify-end">
                          <v-list flat class="transparent pa-0 mx-0">
                            <v-list-item class="px-0">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span class="error--text size-16 weight-800">
                                    {{ car_rent_order.sub_total }}
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon
                                v-if="
                                  car_rent_order.over_prices &&
                                    car_rent_order.over_prices.length === 0 &&
                                    car_rent_order.payment &&
                                    car_rent_order.payment.currency_state
                                "
                              >
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="#a5a5a5"
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      mdi-help-circle
                                    </v-icon>
                                  </template>
                                  <span>
                                    {{ $t("almost_equal") }}
                                  </span>
                                  <span
                                    >{{
                                      car_rent_order.payment &&
                                        car_rent_order.payment.currency_state
                                          .main_amount
                                    }}
                                    {{
                                      car_rent_order.payment &&
                                        car_rent_order.payment.currency_state
                                          .currency.name
                                    }}</span
                                  >
                                </v-tooltip>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <!-- special order -->
                <v-row v-if="car_rent_order.over_prices.length > 0">
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("special_order") }}
                      </span>
                    </v-chip>
                  </v-col>
                  <v-col cols="12">
                    <v-card flat class="orders__invoice">
                      <v-container>
                        <v-row
                          v-for="(over_price,
                          index) in car_rent_order.over_prices"
                          :key="index"
                        >
                          <v-col
                            cols="12"
                            lg="6"
                            class="align-self-center d-flex"
                          >
                            <span class="secondary--text size-16 weight-800">
                              {{ over_price.reason }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6" class="py-0">
                            <v-list flat class="transparent pa-0 mx-0">
                              <v-list-item class="px-0">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <span
                                      class="primary--text size-16 weight-800"
                                    >
                                      {{ over_price.value }}
                                    </span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions class="px-0 mx-0 d-flex flex-wrap">
                        <v-col
                          cols="12"
                          lg="6"
                          class="align-self-center d-flex"
                        >
                          <span class="error--text size-16 weight-800">
                            {{ $t("table.total_price") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="py-0">
                          <v-list flat class="transparent pa-0 mx-0">
                            <v-list-item class="px-0">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span class="error--text size-16 weight-800">
                                    {{ car_rent_order.grand_total }}
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon
                                v-if="
                                  car_rent_order.payment &&
                                    car_rent_order.payment.currency_state
                                "
                              >
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="#a5a5a5"
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      mdi-help-circle
                                    </v-icon>
                                  </template>
                                  <span>
                                    {{ $t("almost_equal") }}
                                  </span>
                                  <span
                                    >{{
                                      car_rent_order.payment &&
                                        car_rent_order.payment.currency_state
                                          .main_amount
                                    }}
                                    {{
                                      car_rent_order.payment &&
                                        car_rent_order.payment.currency_state
                                          .currency.name
                                    }}</span
                                  >
                                </v-tooltip>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <!-- order details -->
                <v-row>
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("details") }}
                      </span>
                    </v-chip>
                  </v-col>
                  <v-col cols="12">
                    <v-card flat class="orders__invoice">
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-row>
                              <v-col cols="12" lg="6">
                                <h3 class="secondary--text">
                                  {{
                                    car_rent_order.car_rent &&
                                      car_rent_order.car_rent.name
                                  }}
                                </h3>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" lg="6">
                            <div class="d-flex align-center">
                             
                                {{ $t("car_rent_max_allowed_km") }}
                              <span class="px-2">
                                {{
                                  car_rent_order &&
                                    car_rent_order.car_rent_max_allowed_km
                                }}
                              
                              </span>
                            </div>
                          </v-col>
                             <v-col cols="12" lg="6">
                            <div class="d-flex align-center">
                              <span class="px-2">
                                {{ $t("duration_in_hours") }}
                              </span>
                              <span class="primary--text font-bold">
                                {{
                                  car_rent_order &&
                                    car_rent_order.car_rent.duration_in_hours
                                }}
                              </span>
                            </div>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <div class="d-flex align-center">
                              <span class="px-2">
                                {{ $t("meeting_point") }}
                              </span>
                              <span class="primary--text font-bold">
                                {{
                                  car_rent_order &&
                                    car_rent_order.meeting_point
                                }}
                              </span>
                            </div>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            v-if="
                              car_rent_order.car_rent &&
                                car_rent_order.car_rent.media
                            "
                          >
                            <v-card class="orders__media-card" v-if="dialog">
                              <MediaSlider
                                :items="car_rent_order.car_rent.media"
                              />
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-row> </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
                <user-details
                  :userDetails="car_rent_order.user"
                  v-if="Object.keys(car_rent_order.user).length"
                />
              </v-col>
              <v-col cols="12" lg="4">
                <v-row>
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("order_status") }}
                      </span>
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row style="height: 97%">
                  <v-col cols="12" class="d-flex flex-column">
                    <v-row>
                      <v-col cols="12">
                        <OrderStatus :item="car_rent_order" />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="align-self-end">
                        <v-row>
                          <v-col cols="12">
                            <v-btn
                              depressed
                              block
                              large
                              class="primary"
                              :disabled="car_rent_order.accepted"
                              @click="handleAcceptOrder"
                            >
                              <span class="white--text font-bold">
                                {{ $t("accept") }}
                              </span>
                            </v-btn>
                          </v-col>
                          <!-- <v-col cols="12">
                            <template v-if="car_rent_order.can_cancel">
                              <v-btn
                                outlined
                                @click="handleCancel"
                                depressed
                                block
                                large
                                color="red"
                                class="mt-2"
                              >
                                <span class="red--text font-bold">
                                  {{ $t("cancel_order") }}
                                </span>
                              </v-btn>
                            </template>
                          </v-col> -->
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="car_rent_order.has_special_request">
                <template>
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("special_order") }}
                      </span>
                    </v-chip>
                  </v-col>
                  <v-col>
                    <p>{{ car_rent_order.special_request_details }}</p>
                  </v-col>
                </template>
              </v-col>
              <v-col cols="12" v-if="car_rent_order.has_special_request">
                <overPrices :order="car_rent_order" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card min-height="200px" max-width="1000px" v-else>
        <loader class="h-100" />
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import { IndexData, StoreData } from "@/helpers/apiMethods";

export default {
  name: "PackagesOrder",
  components: {
    OrderStatus: () => import("./Status.vue"),
    overPrices: () => import("./overPrices.vue"),
    UserDetails: () => import("../sharedCmp/userDetails.vue")
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      car_rent_order: {},
      loading: true
    };
  },
  methods: {
    handleAcceptOrder() {
      const formData = new FormData();
      formData.append("_method", "put");
      formData.append("accept", 1);
      this.popUp().then(value => {
        if (!value.dismiss) {
          StoreData({
            reqName: `car-rent-orders/${this.car_rent_order.reference_number}`,
            data: formData
          })
            .then(() => {
              this.$emit("update:dialog");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleCancel() {
      this.popUp().then(res => {
        if (!res.dismiss) {
          StoreData({
            reqName: `car-rent-orders/${this.item.reference_number}`
          }).then(() => {
            this.$emit("update:dialog");
            this.$emit("refresh");
          });
        }
      });
    },

    handleShow() {
      IndexData({ reqName: `car-rent-orders/${this.item.reference_number}` })
        .then(res => {
          const { car_rent_order } = res.data;
          this.car_rent_order = car_rent_order;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    dialog: {
      handler(value) {
        if (value) {
          this.handleShow();
        } else {
          this.loading = true;
          this.$emit("refresh-table");
        }
      },
      immediate: true
    }
  }
};
</script>
